import getResponseJson from './getresponsejson';

const reportSubscriptionService = serviceRoutes => {
    const init = () => {
      return fetch(serviceRoutes.route, {
        credentials: 'include'
      })
      .then(getResponseJson)
      .then(responseJson => {
        const { result } = responseJson;
        return Promise.resolve(result);
      });
    };
  
    const runReportSubscription = subscriptionId => {
      return fetch(`${serviceRoutes.route}?subscriptionId=${subscriptionId}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        subscriptionId
      })
    })
      .then(getResponseJson)
      .then(responseJson => {
        const { result } = responseJson;
        return Promise.resolve(result);
      });
    };
  
    return {
      init,
      runReportSubscription,
      serviceRoutes
    };
  };
  
  export default reportSubscriptionService;